import { Component, computed, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  standalone: true,
  selector: 'eiq-icon-badge',
  templateUrl: './icon-badge.component.html',
  styleUrls: ['./icon-badge.component.scss', './_icon-badge-theme.component.scss'],
  imports: [FontAwesomeModule]
})
export class IconBadgeComponent {
  icon$ = input.required<IconDefinition>();
  color$ = input<UiPalette>('primary');
  size$ = input<'small' | 'medium'>('medium');

  protected readonly badgeClass$ = computed(() => [`icon-badge--${this.color$()}`, `icon-badge--${this.size$()}`].join(' '));
}
